import { render, staticRenderFns } from "./AddressResponsibleEmployeeDialog.vue?vue&type=template&id=840c70d0&scoped=true&lang=pug&"
import script from "./AddressResponsibleEmployeeDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressResponsibleEmployeeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840c70d0",
  null
  
)

export default component.exports